const dataDisplay_routes = {
      path: "/dataDisplay",
      name: "DataDisplay",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: "dd",
          component: () => import("@/views/training_dataDisplay/Home"),
          meta: {requiresAuth: true}
        },
        /* 机构列表 */
        {
          path: "org",
          component: () => import("@/views/system_manager/organization/org-organization"),
          meta: {requiresAuth: true}
        },
      ]
}

export default dataDisplay_routes;
